var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsInReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#39B54A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1141 31.7117L46.3116 25.553C47.2378 24.9355 47.4816 23.668 46.8641 22.758L43.9066 18.3542C43.2891 17.428 42.0216 17.1842 41.1116 17.8017L31.9141 23.9605L37.1141 31.7117Z",
    fill: "#095228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 30.9341L33.7345 32.8516L29.3957 35.7603L28.827 36.1341L28.567 35.7441L24.927 30.3166L24.667 29.9266L32.4345 24.7266L36.5945 30.9341Z",
    fill: "#095228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.165 40.0339L28.5838 35.7439L24.9438 30.3164L18.525 34.6064C17.7775 35.1102 17.5825 36.1177 18.0863 36.8652L19.9225 39.5952C20.41 40.3427 21.4175 40.5377 22.165 40.0339Z",
    fill: "#095228"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9105 49.4428C39.748 49.5078 39.5693 49.5566 39.4068 49.5566C38.9355 49.5566 38.4968 49.2803 38.2855 48.8253L32.2243 35.4353L26.0818 48.8416C25.8705 49.2803 25.4318 49.5566 24.9605 49.5566C24.798 49.5566 24.6193 49.5078 24.4568 49.4428C23.8555 49.1503 23.5793 48.4353 23.8555 47.8178L29.3968 35.7603L33.7355 32.8516L40.5118 47.8341C40.788 48.4353 40.5118 49.1666 39.9105 49.4428Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsInReview);
export default __webpack_public_path__ + "static/media/ads-in-review.c4d25dbb6edde4e2bef17aa21ba52cd5.svg";
export { ForwardRef as ReactComponent };